import { useMemo } from "react";

import { filters } from "../../../../../../builders/employeeSchedule.builder";
import { STATUS_THEME, ERP_TO_DESIGN_KEY } from "../helpers/status.map";

import { Chevron, CalendarSmall } from "../icons";

import { ScheduleToolbarStyles } from "./scheduleToolbar.styles";

const fmtDate = d =>
  d
    ? d.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric"
      })
    : "";

const ScheduleToolbar = ({
  dateQuery,
  setDateQuery,
  includedStatuses,
  setIncludedStatuses,
  showUnassigned,
  setShowUnassigned,
  unassignedCount,
  employees
}) => {
  const counts = useMemo(() => {
    const out = {};
    for (const f of filters) out[f.value] = 0;
    for (const w of employees || []) {
      const lists = [
        w.acceptedServices,
        w.inProgressServices,
        w.pausedServices,
        w.finishedServices,
        w.canceledServices
      ];
      for (const list of lists) {
        if (!Array.isArray(list)) continue;
        for (const s of list) {
          if (out[s.status] != null) out[s.status] += 1;
        }
      }
    }
    return out;
  }, [employees]);

  const shiftDay = delta => {
    const next = new Date(dateQuery);
    next.setDate(next.getDate() + delta);
    setDateQuery(next);
  };

  const goToday = () => setDateQuery(new Date());

  const toggleStatus = value => {
    setIncludedStatuses(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  return (
    <ScheduleToolbarStyles>
      <div className="date-group">
        <button type="button" onClick={() => shiftDay(-1)} aria-label="Previous day">
          <Chevron dir="l" size={14} />
        </button>
        <div className="date-label">
          <CalendarSmall size={14} />
          {fmtDate(dateQuery)}
        </div>
        <button type="button" onClick={() => shiftDay(1)} aria-label="Next day">
          <Chevron dir="r" size={14} />
        </button>
      </div>
      <button type="button" className="today-btn" onClick={goToday}>
        Today
      </button>

      <div className="divider" />

      <div className="show-label">Show</div>
      <div className="chips">
        {filters.map(f => {
          const on = includedStatuses.includes(f.value);
          const themeKey = ERP_TO_DESIGN_KEY[f.value];
          const palette = STATUS_THEME[themeKey];
          const style = on
            ? {
                ["--chip-bg"]: palette.bg,
                ["--chip-fg"]: palette.fg,
                ["--chip-color"]: palette.chip,
                ["--chip-border"]: palette.chip + "55"
              }
            : undefined;
          return (
            <button
              key={f.value}
              type="button"
              className={`chip ${on ? "on" : ""}`}
              style={style}
              onClick={() => toggleStatus(f.value)}
            >
              <span className="dot" />
              {f.label}
              <span className="count">{counts[f.value] || 0}</span>
            </button>
          );
        })}
      </div>

      <div className="spacer" />

      <button
        type="button"
        className={`unassigned-btn ${showUnassigned ? "on" : ""}`}
        onClick={() => setShowUnassigned(v => !v)}
      >
        Unassigned
        <span className="badge">{unassignedCount}</span>
      </button>
    </ScheduleToolbarStyles>
  );
};

export default ScheduleToolbar;
